// extracted by mini-css-extract-plugin
module.exports = {"saveToCsvButton":"-SaveToCsvButton-saveToCsvButton-1WCFwh-","label":"-SaveToCsvButton-label-1h_FGz-","lightMode":"-SaveToCsvButton-lightMode-vvcg8f-"};